import { Player } from '../game/Player';

export abstract class Mask {
  public readonly name: string;
  public readonly description: string;
  public readonly color: number;
  protected player: Player;
  protected isActive: boolean = false;
  
  // Ability state
  protected abilityActive: boolean = false;
  protected abilityCooldown: number = 0;
  protected abilityDuration: number = 0;
  protected maxAbilityDuration: number = 3;
  protected cooldownTime: number = 5;
  
  constructor(name: string, description: string, color: number, player: Player) {
    this.name = name;
    this.description = description;
    this.color = color;
    this.player = player;
  }
  
  public activate(): void {
    this.isActive = true;
    this.onActivate();
  }
  
  public deactivate(): void {
    this.isActive = false;
    this.abilityActive = false;
    this.onDeactivate();
  }
  
  public update(deltaTime: number): void {
    if (this.abilityCooldown > 0) {
      this.abilityCooldown -= deltaTime;
    }
    
    if (this.abilityActive) {
      this.abilityDuration -= deltaTime;
      if (this.abilityDuration <= 0) {
        this.endAbility();
      }
    }
    
    this.onUpdate(deltaTime);
  }
  
  public useAbility(): boolean {
    if (!this.isActive || this.abilityCooldown > 0 || this.abilityActive) {
      return false;
    }
    
    this.abilityActive = true;
    this.abilityDuration = this.maxAbilityDuration;
    this.onAbilityStart();
    return true;
  }
  
  protected endAbility(): void {
    this.abilityActive = false;
    this.abilityCooldown = this.cooldownTime;
    this.onAbilityEnd();
  }
  
  public isAbilityActive(): boolean {
    return this.abilityActive;
  }
  
  public getCooldownPercent(): number {
    return Math.max(0, this.abilityCooldown / this.cooldownTime);
  }
  
  // Override these in subclasses
  protected abstract onActivate(): void;
  protected abstract onDeactivate(): void;
  protected abstract onUpdate(deltaTime: number): void;
  protected abstract onAbilityStart(): void;
  protected abstract onAbilityEnd(): void;
}
